module.exports = "img/taller-ing-2.e47e08.jpg";